import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { verifyAccount } from 'src/app/_actions/verify-account.actions';
import { resetInvalidCodeState } from 'src/app/_actions/verify-code-state.actions';
import { VerifyAccountRequest, VerifyCodeRequest } from 'src/app/_models/verify-account';
import brandInfo from '../../../../environments/brand.json'
import { showInlineLoader } from 'src/app/_actions/inline-loader.actions';


@Component({
  selector: 'app-my-account-verify-phone',
  standalone: false,
  templateUrl: './my-account-verify-phone.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrls: ['./my-account-verify-phone.component.scss']
})
export class MyAccountVerifyPhoneComponent implements OnInit, OnChanges {
  @Output() verifyCodeRequest: EventEmitter<VerifyCodeRequest> = new EventEmitter<VerifyCodeRequest>();
  @Output() viewEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() verifyType: EventEmitter<string> = new EventEmitter<string>();
  @Input() phoneReset: boolean
  verifyAccount$: Observable<any>;
  verifyAccountSubscription: Subscription;
  inlineLoader$: Observable<any>;

  session$: Observable<any>;
  accountPhoneValidationForm: UntypedFormGroup;
  website: string;
  useLegalFolder = true;
  thisLang = sessionStorage.getItem("preferredLanguage") ? sessionStorage.getItem("preferredLanguage") : brandInfo.language;

  constructor(
    public store: Store<{
      session: any,
      verifyAccount: any,
      inlineLoader: any

    }>
  ) { }

  ngOnInit(): void {
    this.session$ = this.store.select(store => store.session)
    this.inlineLoader$ = this.store.select(store => store.inlineLoader)
    
    this.website = window.location.hostname;
    if (brandInfo.brand === 'NCESI') { // Nissan Canada different legal link structure
      this.useLegalFolder = false;
    }

    this.accountPhoneValidationForm = new UntypedFormGroup({
      phoneNumber: new UntypedFormControl(null, [Validators.required,Validators.pattern(/^-?(0|[1-9]\d*)?$/),Validators.minLength(10)]),
      lastName: new UntypedFormControl(null, Validators.required),
    });
      this.verifyAccount$ = this.store.select(store => store.verifyAccount)
  }

  ngOnChanges() {
    this.resetForm(this.phoneReset)
  }
  ngOnDestroy() {
    if(this.verifyAccountSubscription) {
      this.verifyAccountSubscription.unsubscribe()
    }
  }

  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  verifyAccountPhone() {
    this.store.dispatch(resetInvalidCodeState())

    let verifyAccountRequest: VerifyAccountRequest = {
      brandName: brandInfo.brand,
      emailId: null,
      phoneNumber: this.accountPhoneValidationForm.controls["phoneNumber"].value,
      contactType: 'phone',
      lastName: this.accountPhoneValidationForm.controls["lastName"].value
    }

    let verifyCodeRequest = {
      contact: this.accountPhoneValidationForm.controls["phoneNumber"].value,
      contactType: 'phone',
      lastName: this.accountPhoneValidationForm.controls["lastName"].value,
      code: ''
    }

    //this.store.dispatch(resetSession())
    this.store.dispatch(showInlineLoader())
    this.store.dispatch(verifyAccount(verifyAccountRequest))

    this.verifyCodeRequest.emit(verifyCodeRequest)
    this.verifyType.emit('phone')

    this.verifyAccountSubscription = this.verifyAccount$.subscribe(data => {
      if (data)
      {
        if (data?.errorMessage === '' || data?.errorMessage === null || data?.errorMessage === 'null') {
          this.viewEmitter.emit('2')
        }
      }
    })

    this.verifyType.emit('phone')
  }

  resetForm(data) {
    if (data === true) {
      this.accountPhoneValidationForm.reset()
    }
  }
}
